import { Ranking } from '@opositandopn/ui';
import classnames from 'classnames';

import { BaseComponentProps } from '../../../../types/base-component.types';
import { PlayerViewModel } from '../../../challenges/api/useChallenges';

import styles from './ChallengeRanking.module.scss';

export type ContainerProps = BaseComponentProps & {
  players: PlayerViewModel[];
  /**
   * What the first column is called. The board stands for the match while it is
   * still being played and for the people who played it once it is over, and the
   * two rounds of the challenge word it differently.
   */
  playersColumn?: string;
};

/**
 * The scoreboard of a 1v1 challenge — drawn the same between rounds and at the
 * end, so the board the reader has been following does not change shape under
 * them when the match closes.
 */
function ChallengeRanking({
  className,
  players,
  playersColumn = 'Jugador',
  testId = 'ui-challenge-ranking',
}: ContainerProps) {
  return (
    <Ranking
      className={classnames(styles['ranking'], className)}
      testId={testId}
      columns={[playersColumn, 'Puntuación']}
      // Sorted on a copy: the caller's list is state held elsewhere, and the
      // order the board wants is the board's own business.
      rows={[...players]
        .sort((a, b) => (a.score < b.score ? 1 : -1))
        .map((item) => ({
          cells: [item.username, item.score.toString()],
        }))}
    />
  );
}

export { ChallengeRanking };
